import React from "react";
import {useSelector, useDispatch} from "react-redux";
import _ from "lodash";
import {FormFieldInput} from "ui-components-rollup/dist/Forms";
import FormFieldSelect from "../../../../../components/widgets/FormFieldSelect";
import { ReactComponent as InlineLoader } from "ui-components-rollup/src/images/loaders/inline-loader.svg";
import styles from "./Form.module.scss";
import commonStyles from "../../../styles/common.module.scss";
import classNames from "classnames";

export default ({ onFormSubmit, handleFormSubmit, handleFormChange, formState, formErrors, submissionAttempted }) => {
    const dispatch = useDispatch();
    const projects = useSelector(state => _.get(state, "cvs2.gcpProjects"));
    const fetchProjectPending = useSelector(state => _.get(state, "cvs2.fetchGcpProjectPending"));
    const handleCredentialsSubmission = () => {
        try {
            const credentials = JSON.parse(formState.serviceAccountCredentials);
            dispatch({
                type: "CVS2:FETCH-GCP-PROJECTS",
                payload: { credentials }
            });
        } catch (e) {
            formErrors.serviceAccountCredentials = "Invalid JSON format."
        }
    };
    return (
        <form className={styles["form"]} onSubmit={handleFormSubmit(onFormSubmit)}>
            <FormFieldInput
                type="text"
                name="name"
                label="Azure NetApp Files Name"
                value={formState.name}
                onChange={handleFormChange}
                charCount={true}
                maxChars={256}
                errorMessage={submissionAttempted && formErrors.name}
            />
            <div className={styles["gcp-json"]}>
                <FormFieldInput
                    type="text"
                    isTextArea={true}
                    name="serviceAccountCredentials"
                    label="Azure NetApp Files Name"
                    placeholder="Paste the contents of the JSON file here"
                    value={formState.serviceAccountCredentials}
                    onChange={handleFormChange}
                    errorMessage={submissionAttempted && formErrors.serviceAccountCredentials}
                />
                { fetchProjectPending
                    ? <InlineLoader className={commonStyles["inline-loader"]}/>
                    : <button onClick={() => handleCredentialsSubmission()} className={commonStyles["primary-button"]}>Apply</button>
                }
            </div>
            {projects &&
            <FormFieldSelect
                isCreatable={false}
                name="project"
                label="Project"
                placeholder="- Please Select -"
                onChange={handleFormChange}
                isClearable={true}
                isSearchable={true}
                isMulti={false}
                options={projects}
                value={formState.project}
                errorMessage={submissionAttempted && formErrors.project}
                // isDisabled={serviceName === "all"}
            />
            }
        </form>
    );
};
